import { BRAND } from "@/lib/brand";
import { cn } from "@/lib/utils";

type LogoMarkProps = {
  size?: number;
  className?: string;
};

/**
 * The Flock mark: a lead bird with two followers in formation.
 * One bird today (your Codex, always aloft) — a whole flock tomorrow.
 * Drawn in currentColor so it adapts to any surface.
 */
export function LogoMark({ size = 28, className }: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M8.5 12.5 L16 6 L23.5 12.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 23 L9.5 17.8 L15.5 23"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.45"
      />
      <path
        d="M16.5 23 L22.5 17.8 L28.5 23"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.45"
      />
    </svg>
  );
}

type LogoProps = {
  showWordmark?: boolean;
  iconSize?: number;
  className?: string;
};

export function Logo({ showWordmark = true, iconSize = 24, className }: LogoProps) {
  return (
    <div className={cn("inline-flex items-center gap-2 text-zinc-900", className)}>
      <LogoMark size={iconSize} />
      {showWordmark && (
        <span className="text-lg font-semibold tracking-tight">{BRAND.name}</span>
      )}
    </div>
  );
}
